import { useNavigate, Link } from "react-router-dom";
import { User, Mail, Phone, MapPin, LogOut, ShieldCheck, LayoutDashboard, UtensilsCrossed, Ticket, ChevronRight, Terminal } from "lucide-react";
import { useAuthStore } from "../store/authStore";

export default function Profile() {
  const nav = useNavigate();
  const { user, logout } = useAuthStore();
  const isAdmin = user?.role === "admin" || user?.role === "manager";

  const navItem = (to, Icon, label, sub, testid) => (
    <Link to={to} data-testid={testid}
      className="flex items-center gap-3 py-3.5" style={{ borderBottom: "1px solid #f1f5f9" }}>
      <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: "#eef6f2" }}><Icon size={18} color="#075A43" /></div>
      <div className="flex-1">
        <p className="text-sm font-bold" style={{ color: "#0b1220" }}>{label}</p>
        <p className="text-xs" style={{ color: "#94a3b8" }}>{sub}</p>
      </div>
      <ChevronRight size={18} color="#cbd5e1" />
    </Link>
  );

  const row = (Icon, label, value) => (
    <div className="flex items-center gap-3 py-3" style={{ borderBottom: "1px solid #f1f5f9" }}>
      <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: "#f8fafc" }}><Icon size={18} color="#0b1220" /></div>
      <div>
        <p className="text-xs" style={{ color: "#94a3b8" }}>{label}</p>
        <p className="text-sm font-semibold" style={{ color: "#0b1220" }}>{value || "—"}</p>
      </div>
    </div>
  );

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="rounded-2xl p-6 mb-6" style={{ background: "linear-gradient(135deg,#0B0F16,#1E0A03)" }}>
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: "#E8C98A" }}>
            <User size={30} color="#0B0F16" />
          </div>
          <div>
            <p className="text-xl font-extrabold" style={{ color: "#F2F2F2" }}>{user?.name}</p>
            <span className="inline-flex items-center gap-1 text-xs font-bold px-2 py-0.5 rounded-full mt-1" style={{ background: "rgba(232,201,138,0.2)", color: "#E8C98A" }}>
              <ShieldCheck size={12} /> {user?.role === "client" ? "Client" : user?.role}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-5" style={{ border: "1px solid #f0f0f0" }}>
        <h2 className="text-sm font-extrabold tracking-widest mb-2" style={{ color: "#64748b" }}>MES INFORMATIONS</h2>
        {row(Mail, "Email", user?.email)}
        {row(Phone, "Téléphone", user?.phone)}
        {row(MapPin, "Adresse", user?.address)}
      </div>

      {isAdmin && (
        <div className="bg-white rounded-2xl p-5 mt-5" style={{ border: "1px solid #f0f0f0" }} data-testid="profile-founder">
          <h2 className="text-sm font-extrabold tracking-widest mb-1" style={{ color: "#075A43" }}>ESPACE FOUNDER</h2>
          {navItem("/tuluss-root", Terminal, "Tableau de bord Root · TULUSS", "Toutes les données + administration TULUSS", "profile-founder-root")}
          {navItem("/founder/supervision", LayoutDashboard, "Supervision", "Partenaires, commandes, stock", "profile-founder-supervision")}
          {navItem("/restaurant-partenaire", UtensilsCrossed, "Catalogue La BASE Maison", "Kiosk · Pharmacie · Restaurant · Boissons", "profile-founder-catalog")}
          {navItem("/founder/formules", Ticket, "Formules commerciales", "Livraison offerte · 2e à -50 % · codes", "profile-founder-formules")}
        </div>
      )}

      <button onClick={() => { logout(); nav("/login"); }} data-testid="profile-logout"
        className="w-full rounded-xl font-bold py-3.5 mt-6 flex items-center justify-center gap-2" style={{ background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca" }}>
        <LogOut size={20} /> Se déconnecter
      </button>
    </div>
  );
}
